// Add your custom JS here.
jQuery(window).scroll(function () {
    if (jQuery(this).scrollTop() > 50) {
        jQuery('header.header-site').addClass('scrolled');
    } else {
        jQuery('header.header-site').removeClass('scrolled');
    }
});

jQuery(document).ready(function($) {

    /* Search - Nav */
    var searchMenuLink = $('.dropdown-toggle-search');
    var searchDropdown = $('.dropdown-menu--search');

    searchMenuLink.on('click', function(e) {
        e.preventDefault();
        searchDropdown.toggle();
        searchMenuLink.toggleClass('open');
    });

    $(document).on('click', function(e) {
        if (!$(e.target).closest('.dropdown-menu--search').length && !$(e.target).closest('.dropdown-toggle-search').length) {
            searchDropdown.hide();
            searchMenuLink.removeClass('open');
        }
    });
    
    jQuery('.drop-down-icon-mobile').click(function(){
  

        if(jQuery(this).parent().hasClass('active-nav')){
            jQuery(this).parent().removeClass('active-nav');
        }else{
            jQuery(this).parent().addClass('active-nav');
        }
    }); 
});

jQuery(document).ready(function($) {
    $('[tabindex="0"]').keydown(function(event) {
      if (event.key === 'Enter' || event.key === ' ') {
        $(this).click();
      }
    });
  });
/* jQuery(function($) {
    $('.navbar .dropdown').hover(function() {
        $(this).find('.dropdown-menu').first().stop(true, true).delay(250).slideDown();
    }, function() {
        $(this).find('.dropdown-menu').first().stop(true, true).delay(100).slideUp();
    });
    
    $('.navbar .dropdown > a').click(function(){
        location.href = this.href;
    });
    
}); */

/*skip content*/
document.addEventListener('DOMContentLoaded', function() {
    const LinkGoSecondSection = document.getElementById('GoSecondSection');
    LinkGoSecondSection.addEventListener('click', function(event) {
        event.preventDefault();
        const secondSection = document.querySelector('.general-section:nth-of-type(2)');
        if (secondSection) {
            secondSection.scrollIntoView({ behavior: 'smooth' });
        } else {
            console.error('the second section was not found.');
        }
    });
});

/*Menu nav*/
jQuery(document).ready(function() {
    const menuItemsWithSubmenu = jQuery('.navbar-nav > li');
    menuItemsWithSubmenu.each(function(index, menuItem) {
        const submenu = jQuery(menuItem).find('.dropdown-menu');
        const ignoreClass = 'nav-search';
        if (!jQuery(menuItem).hasClass(ignoreClass)) {
            jQuery(menuItem).on('mouseenter', function() {
                if (submenu.length > 0) {
                    submenu.css('display', 'block');
                    const menuItemRect = menuItem.getBoundingClientRect();
                    const submenuHeight = submenu.outerHeight();
                    submenu.css('top', menuItemRect.height + 'px');
                }
            });
            jQuery(menuItem).on('mouseleave', function() {
                if (submenu.length > 0) {
                    submenu.css('display', 'none');
                }
            });
        }
    });
});

/*Intective txtarea form*/
jQuery('.ginput_container_textarea .textarea').each(function() {
    jQuery(this).css('height', '40px');
});

/*functionality in the menu*/
jQuery(document).ready(function() {
    jQuery('header input').on('input', function() {
        jQuery(this).val(jQuery(this).val().toUpperCase());
    });

    jQuery('header input').each(function() {
        jQuery(this).val('');
    });
});

jQuery('textarea').attr('rows','1')


document.querySelectorAll('textarea').forEach(function(textarea) {
    textarea.addEventListener('input', autosize);
});

function autosize() {
    var el = this;
    setTimeout(function() {
        el.style.cssText = 'height:auto; padding:0';
        // for box-sizing other than "content-box" use:
        // el.style.cssText = '-moz-box-sizing:content-box';
        el.style.cssText = 'height:' + (el.scrollHeight + 2) + 'px';
    }, 0);
}


jQuery(document).ready(function($) {

    
  //  jQuery(document).ready(function($) {
    jQuery("a, button, input, select, textarea").filter(":visible").first().focus();
   // });
 //  document.querySelector("div:first-of-type").focus();

    $('[tabindex="0"]').keydown(function(event) {
        if (event.key === 'Enter' || event.key === ' ') {
            $(this).click();
        }
    });
    
    jQuery('.navbar-nav .menu-item-has-children > a').on('focus', function() {
        jQuery('.navbar-nav').addClass('key-focus-main');
        var current_item_parent = jQuery(this).closest('.menu-item-has-children');
        jQuery(this).attr('aria-expanded','false' );
        current_item_parent.addClass('parent-focus-main');

    }).on('blur', function() {
        jQuery('.navbar-nav').removeClass('key-focus-main');
        jQuery('.navbar-nav').addClass('key-focus-main');
    });

    jQuery('.navbar-nav .menu-item-has-children .dropdown-menu  a').on('focus', function() {
        var current_item_parent = jQuery(this).closest('.parent-focus-main');
        jQuery(this).attr('aria-expanded','false' );
        current_item_parent.addClass('active-item-sub');
    }).on('blur', function() {
        jQuery('.navbar-nav').removeClass('key-focus-main');
        jQuery('.navbar-nav').addClass('key-focus-main');
        var current_item_parent = jQuery(this).closest('.parent-focus-main');
    });
    jQuery(document).click(function(event) {
        if (!jQuery(event.target).closest('.parent-focus-main').length) {
            jQuery('.menu-item-has-children').removeClass('active-item-sub'); 
        }
    });
    jQuery('.navbar-nav .menu-item-has-children > a').keydown(function(event) {
        var atribute_current =  jQuery(this).attr('aria-expanded');
        console.log(atribute_current);
        if (event.key === 'Enter') {
          if(atribute_current === 'false'){ 
            event.preventDefault();
            jQuery(this).attr('aria-expanded','false' );
            jQuery('.menu-item-has-children').removeClass('active-item-sub'); 
            var current_item_parent = jQuery(this).closest('.menu-item-has-children');
            jQuery(this).attr('aria-expanded','true' );
            current_item_parent.addClass('active-item-sub');
          } 
        }
      });

      jQuery('a').on('focus', function() {
        if (!jQuery(this).closest('.parent-focus-main').length) {
            jQuery('.menu-item-has-children').removeClass('active-item-sub'); 
        }

    }).on('blur', function() {
        
    });

});

/* $('.check-event-fill').on('change', function(){  
    if(this.checked) {
          //id_name_event
          //id_last_name_event
          //id_email_event
          //id_company_event
          //id_phone_event  
     }
 }) */